import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import { prepareApiDataForUpdate, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import type { CsticUpdate } from "~/Configurators/Linear/api/sendLinearConfiguratorUpdate";
import { KmatType } from "~/Configurators/Linear/getKmatType";
import * as CarriageCstic from "~/Configurators/Carriage/v2/configuration/CarriageCstics";

export function sendCarriageDetailsReset(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);

  data.carriagesConfiguratorData.enableConfigureCarriageValues = false;

  const updatedCstics: CsticUpdate[] = [];

  updatedCstics.push({
    key: CarriageCstic.StandardKits,
    type: KmatType.CARRIAGE,
    index: 0,
    value: "S",
  });
  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  prepareGroupIdToDisplay(data);

  return sendCarriage({
    ...data,
    ...updateData,
  });
}
